export const environment = {
  production: true,
  prefix: 'tms-stage',
  frontendBaseUrl: 'https://tms-stage.nstechs.co',
  backendBaseUrl: 'https://backend-stage.nstechs.co',
  firebase: {
    apiKey: 'AIzaSyCUON3zetVTbXGGCnmhmBfbV4dPNRYwWNM',
    authDomain: 'ns-tms-live.firebaseapp.com',
    projectId: 'ns-tms-live',
    storageBucket: 'ns-tms-live.firebasestorage.app',
    messagingSenderId: '74191178738',
    appId: '1:74191178738:web:bd0933abbc77da23a5f96b',
    measurementId: 'G-RXP5GNLCTK',
    vapidKey:
      'BBB3lj2GW0_N4nSPw_W8b7TwzEF35pk18o2tSaezMbp3dFWQa_NlmvlN4J4xufX8FTm9pfFxUoIlcXxWIZh1pTk',
    clientId:
      '74191178738-k7o1c5guvbgdoc58ugmnhl90vs233rbv.apps.googleusercontent.com',
  },
};
